import { useState, useEffect } from 'react'

export function useCountdown(initialSeconds = 1800) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 0) return initialSeconds
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [initialSeconds])

  const hours = Math.floor(timeLeft / 3600)
    .toString()
    .padStart(2, '0')
  const minutes = Math.floor((timeLeft % 3600) / 60)
    .toString()
    .padStart(2, '0')
  const seconds = (timeLeft % 60).toString().padStart(2, '0')

  return { hours, minutes, seconds }
}
